import React from "react";
import { useSelector, useDispatch } from "react-redux";
import LeftSideBar from "./components/LeftSideBar";
import TableOfContents from "./components/TableOfContents";
import { closeTOC } from "../actions/navigationActions";

const Drawer = () => {
  const dispatch = useDispatch();

  const { openTOC } = useSelector((state) => ({
    ...state.navigationReducer,
  }));

  const generateClassName = () => {
    return openTOC ? "drawer open" : "drawer";
  };
  return (
    <div className={generateClassName()} onClick={() => dispatch(closeTOC())}>
      <LeftSideBar />
      <TableOfContents />
    </div>
  );
};

export default Drawer;
